module.exports = __webpack_public_path__ + "static/media/icon_117.3fc1ba37.svg";